import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=01553288&scoped=true&"
import script from "./approver.vue?vue&type=script&lang=js&"
export * from "./approver.vue?vue&type=script&lang=js&"
import style0 from "./approver.vue?vue&type=style&index=0&lang=less&"
import style1 from "./approver.vue?vue&type=style&index=1&id=01553288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01553288",
  null
  
)

export default component.exports